module.exports = __webpack_public_path__ + "img/attention-red.c4b01a78.svg";